module.exports = __webpack_public_path__ + "img/teachers.74ce701a.jpeg";